import React from "react";
import { Link } from "react-router-dom";
import { Users, Leaf, PartyPopper, ArrowRight, Mail } from "lucide-react";
import { Button } from "../components/ui/button";
import PageHero from "../components/PageHero";
import { images, youthInfo, club } from "../mock/mock";

const iconMap = [Users, Leaf, PartyPopper];

export default function Jugend() {
  return (
    <div>
      <PageHero
        eyebrow="Nachwuchs"
        title="Jugendgruppe"
        subtitle="Angeln, Natur erleben und Freundschaften schließen – unsere Jugend ist die Zukunft des Vereins."
        image={images.kidToddler}
      />

      {/* Intro */}
      <section className="py-24 bg-background">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
          <div className="rounded-2xl overflow-hidden shadow-xl">
            <img
              src={images.kidFish}
              alt="Kind mit Fisch"
              className="w-full h-[420px] object-cover"
            />
          </div>
          <div>
            <span className="inline-block text-accent text-sm font-600 uppercase tracking-[0.25em] mb-3">
              Gemeinsam wachsen
            </span>
            <h2 className="font-serif text-4xl md:text-5xl font-600 text-foreground leading-tight">
              Angeln von klein auf
            </h2>
            <p className="mt-6 text-lg text-muted-foreground font-300 leading-relaxed">
              {youthInfo.intro}
            </p>
            <a href={`mailto:${club.emails.anfrage}`} className="inline-block mt-8">
              <Button className="bg-primary hover:bg-primary/90 text-primary-foreground font-500 gap-2">
                <Mail className="h-4 w-4" /> Jetzt anfragen
              </Button>
            </a>
          </div>
        </div>
      </section>

      {/* Activities */}
      <section className="py-24 bg-secondary/50">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid md:grid-cols-3 gap-6">
            {youthInfo.activities.map((a, i) => {
              const Icon = iconMap[i % iconMap.length];
              return (
                <div
                  key={a.title}
                  className="bg-card rounded-2xl p-8 border border-border hover:shadow-lg transition-shadow"
                >
                  <div className="h-14 w-14 rounded-xl bg-primary/10 flex items-center justify-center mb-5">
                    <Icon className="h-7 w-7 text-primary" />
                  </div>
                  <h3 className="font-serif text-2xl font-600 text-foreground mb-2">
                    {a.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">{a.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-primary text-primary-foreground">
        <div className="max-w-3xl mx-auto px-5 text-center">
          <h2 className="font-serif text-3xl md:text-4xl font-600">
            Neugierig geworden?
          </h2>
          <p className="mt-3 text-lg text-primary-foreground/80">
            Kinder und Jugendliche sind bei uns herzlich willkommen. Meldet euch
            über unser Kontaktformular oder per E-Mail.
          </p>
          <Link to="/kontakt" className="inline-block mt-7">
            <Button className="bg-accent hover:bg-accent/90 text-accent-foreground font-600 gap-2">
              Kontakt aufnehmen <ArrowRight className="h-4 w-4" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
